export default __webpack_public_path__ + "static/media/total-assigned-terminals.816469e1.svg";